class LqdTeamMemberHandler extends elementorModules.frontend.handlers.Base {

  onInit(...args) {

    super.onInit(...args);

    this.handleDestroy();

    this.initCustomAnimation();
    this.initReveal();

  }

  getDefaultSettings() {
    return {
      isotopeData: null,
      selectors: {
        customAnimationElement: '[data-custom-animations]',
        revealElement: '[data-reveal]',
      }
    }
  }

  getDefaultElements() {
    const selectors = this.getSettings('selectors');
    return {
      $customAnimationElement: this.$element.find(selectors.customAnimationElement),
      $revealElement: this.$element.find(selectors.revealElement),
    }
  }

  initCustomAnimation() {

    this.elements.$customAnimationElement.liquidCustomAnimations();

  }

  initReveal() {

    this.elements.$revealElement.liquidReveal();

  }

  onDestroy() {

    this.handleDestroy();

    super.onDestroy();

  }

  handleDestroy() {

    this.handleCustomAnimationDestroy();

  }

  handleCustomAnimationDestroy() {

    if ( ! this.elements.$customAnimationElement.length ) return;

    const customAnimationData = this.elements.$customAnimationElement.data('plugin_liquidCustomAnimations');

    if ( customAnimationData ) {
      customAnimationData.destroy();
    }

  }
  
}

export default ($element) => {
  elementorFrontend.elementsHandler.addHandler( LqdTeamMemberHandler, { $element } );
};